import { render } from "./SearchCard.vue?vue&type=template&id=20f02e80"
import script from "./SearchCard.vue?vue&type=script&lang=js"
export * from "./SearchCard.vue?vue&type=script&lang=js"

import "./SearchCard.vue?vue&type=style&index=0&id=20f02e80&lang=scss"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__